import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
    BaseCard,
    Body2,
    Box,
    IconChevronRight,
    Stack,
    Subtitle1,
    TextButton,
} from '@myphx-engineering/phx-design-system';

import configs from '../../../../configuration/lilly-direct';
import { type DigitallyReceivedPrescriberOrderInfoFragment } from '../../../../graphql/generated/graphql';
import { useFlags } from '../../../../hooks/use-flags';
import { useOuraImpressionTracking } from '../../../../hooks/use-oura-impression-tracking';
import type { LillyMarketingPromotionsFlag } from '../../../../types/non-boolean-flags';

import classes from './oura-promotional-module.module.css';

export type OuraPromotionalModuleProps = {
    prescriberOrder: DigitallyReceivedPrescriberOrderInfoFragment;
};

export const OuraPromotionalModule: FC<OuraPromotionalModuleProps> = ({
    prescriberOrder,
}) => {
    const { t } = useTranslation('lilly');
    const { constants } = configs;
    const { lillyMarketingPromotions } = useFlags();
    const flag = lillyMarketingPromotions as LillyMarketingPromotionsFlag;

    useOuraImpressionTracking({
        enabled: flag.enabled,
        prescriberOrderId: prescriberOrder.id,
    });

    if (!flag.enabled) return null;

    return (
        <BaseCard padding={0} radius="sm" className={classes.card}>
            <Box className={classes.background} />
            <Stack gap="xxxs" p="sm" pos="relative">
                <Subtitle1>
                    {t('orderConfirmation.ouraPromo.heading')}
                </Subtitle1>
                <Body2>{t('orderConfirmation.ouraPromo.body')}</Body2>
                <TextButton
                    RightIcon={IconChevronRight}
                    justify="flex-start"
                    onClick={() =>
                        window.open(constants.OURA_SIZING_KIT_URL, '_blank')
                    }
                >
                    {t('orderConfirmation.ouraPromo.cta')}
                </TextButton>
            </Stack>
        </BaseCard>
    );
};
